// Configuration
const storefrontAccessToken = '0e89031243cf5e1e47471f53846ea633';
const graphqlEndpoint = 'https://715857-a7.myshopify.com/api/2023-07/graphql.json';

// Create overlay structure
function createSimilarProductsOverlay() {
  // Remove existing overlay if it exists
  const existingOverlay = document.getElementById('similar-products-overlay');
  if (existingOverlay) {
    existingOverlay.remove();
  }

  const overlay = document.createElement('div');
  overlay.id = 'similar-products-overlay';
  overlay.className = 'similar-products-overlay';
  overlay.innerHTML = `
    <div class="similar-products-content">
      <div class="similar-products-header">
        <h3>SIMILAR PRODUCTS</h3>
        <button class="close-similar-products" aria-label="Close">&times;</button>
      </div>
      <div id="similar-products-grid" class="similar-products-grid"></div>
    </div>
  `;
  
  document.body.insertBefore(overlay, document.body.firstChild);
  return overlay;
}

// Initialize overlay on page load
document.addEventListener('DOMContentLoaded', createSimilarProductsOverlay);

// Track fetch state
let isFetchingProducts = false;

// Handle click events
document.addEventListener('click', function(event) {
  if (event.target.classList.contains('view-similar-btn')) {
    const productId = event.target.dataset.productId;
    
    gtag('event', 'view_similar_click', {
      event_category: 'engagement',
      event_label: 'View Similar Button Clicked',
      product_id: productId
    });
    
    fetchSimilarProducts(productId);
  }
  
  if (event.target.classList.contains('close-similar-products')) {
    const overlay = document.getElementById('similar-products-overlay');
    overlay.style.display = 'none';
    document.body.classList.remove('overlay-active');
    document.body.style.overflow = '';

    gtag('event', 'view_similar_overlay_close', {
      event_category: 'engagement',
      event_label: 'Similar Products Overlay Closed'
    });
  }
});

// Track product clicks
document.addEventListener('click', function(event) {
  const product = event.target.closest('.product-block');
  if (product) {
    const productId = product.dataset.productId;
    gtag('event', 'similar_product_click', {
      event_category: 'engagement',
      event_label: 'Similar Product Clicked',
      product_id: productId
    });
  }
});

// Fetch similar products
function fetchSimilarProducts(productId) {
  if (isFetchingProducts) {
    console.log('Already fetching products, request ignored');
    return;
  }

  isFetchingProducts = true;
  displayLoadingState();

  // fetch(`https://similar-products.themuralstory.com/similar-products/${productId}`)
  fetch(`https://product-similarity.themuralstory.com/api/similar-products/${productId}`)
    
    .then(response => {
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      return response.json();
    })
    .then(similarProductData => {
      const similarProductIds = similarProductData.map(product => product.id);
      if (!Array.isArray(similarProductIds) || similarProductIds.length === 0) {
        throw new Error('No similar products found');
      }
      console.log('Similar Product IDs:', similarProductIds);
      return Promise.all(similarProductIds.slice(0, 4).map(id => fetchProductDetails(id)));
    })
    .then(similarProducts => {
      displaySimilarProducts(productId, similarProducts.filter(Boolean));
    })
    .catch(error => {
      console.error('Error:', error);
      displayErrorMessage('Unable to fetch similar products. Please try again later.');
    })
    .finally(() => {
      isFetchingProducts = false;
    });
}

// Fetch product details using GraphQL
function fetchProductDetails(productId) {
  const query = `
    query {
      product(id: "gid://shopify/Product/${productId}") {
        id
        title
        handle
        description
        vendor
        productType
        tags
        priceRange {
          minVariantPrice {
            amount
          }
        }
        compareAtPriceRange {
          maxVariantPrice {
            amount
          }
        }
        availableForSale
        images(first: 1) {
          edges {
            node {
              originalSrc
              altText
            }
          }
        }
      }
    }
  `;

  return fetch(graphqlEndpoint, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'X-Shopify-Storefront-Access-Token': storefrontAccessToken
    },
    body: JSON.stringify({ query })
  })
    .then(response => {
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      return response.json();
    })
    .then(result => {
      if (result.errors) {
        throw new Error(result.errors.map(e => e.message).join(', '));
      }
      const product = result.data.product;
      if (!product) {
        throw new Error('Product not found');
      }
      return {
        id: product.id.split('/').pop(),
        title: product.title,
        handle: product.handle,
        description: product.description,
        vendor: product.vendor,
        type: product.productType,
        tags: product.tags,
        price: product.priceRange.minVariantPrice.amount,
        compare_at_price: product.compareAtPriceRange.maxVariantPrice.amount,
        available: product.availableForSale,
        featured_image: product.images.edges[0]?.node.originalSrc || '',
        url: `/products/${product.handle}`
      };
    })
    .catch(error => {
      console.error(`Error fetching details for product ${productId}:`, error);
      throw error;
    });
}

// Display loading state
function displayLoadingState() {
  const overlay = document.getElementById('similar-products-overlay') || createSimilarProductsOverlay();
  const grid = document.getElementById('similar-products-grid');
  
  grid.innerHTML = `
    <div class="loading-state">
      <div class="spinner"></div>
    </div>
  `;
  
  overlay.style.display = 'block';
  document.body.classList.add('overlay-active');
  document.body.style.overflow = 'hidden';
}

// Display similar products
function displaySimilarProducts(productId, similarProducts) {
  const overlay = document.getElementById('similar-products-overlay') || createSimilarProductsOverlay();
  const grid = document.getElementById('similar-products-grid');
  grid.innerHTML = '';
  
  if (similarProducts.length === 0) {
    grid.innerHTML = '<p class="no-results">No similar products found.</p>';
  } else {
    similarProducts.slice(0, 4).forEach(product => {
      if (product) {
        const productElement = document.createElement('div');
        productElement.innerHTML = createProductBlock(product, true).trim();
        grid.appendChild(productElement.firstElementChild);
      }
    });
  }
  
  overlay.style.display = 'block';
  document.body.classList.add('overlay-active');
  document.body.style.overflow = 'hidden';
  
  gtag('event', 'view_similar_overlay_open', {
    event_category: 'engagement',
    event_label: 'Similar Products Overlay Opened',
    product_id: productId,
    similar_products_count: similarProducts.length
  });
}

// Display error message
function displayErrorMessage(message) {
  const overlay = document.getElementById('similar-products-overlay') || createSimilarProductsOverlay();
  const grid = document.getElementById('similar-products-grid');
  grid.innerHTML = `<p class="error-message">${message}</p>`;
  
  overlay.style.display = 'block';
  document.body.classList.add('overlay-active');
  document.body.style.overflow = 'hidden';
}

// Create product block HTML
function createProductBlock(product, isInOverlay = false) {
  const twoButtonsContainer = isInOverlay ? '' : `
    <div class="two-buttons-container">
      <a href="${product.url}" class="btn btn--secondary roomvo-visualizer">
        See in My Room
      </a>
      <button class="btn btn--secondary view-similar-btn" data-product-id="${product.id}">
        VIEW SIMILAR
      </button>
    </div>
  `;

  const price = parseFloat(product.price);
  const compareAtPrice = parseFloat(product.compare_at_price);
  
  const priceHtml = compareAtPrice > price 
    ? `
      <div class="product-price">
        <span class="compare-at-price">From Rs. ${compareAtPrice.toFixed(2)}</span>
        <span class="current-price">From Rs. ${price.toFixed(2)}</span>
      </div>
    `
    : `
      <div class="product-price">
        <span class="current-price">From Rs. ${price.toFixed(2)}</span>
      </div>
    `;

  return `
    <div class="product-block" data-product-id="${product.id}">
      <div class="image-cont">
        <a href="${product.url}" class="product-link">
          <img src="${product.featured_image}" alt="${product.title}" class="product-image" loading="lazy">
        </a>
      </div>
      <div class="product-block__detail">
        <div class="inner">
          <div class="innerer">
            <a href="${product.url}" class="product-link">
              <div class="product-block__title">${product.title}</div>
              ${priceHtml}
            </a>
            ${twoButtonsContainer}
          </div>
        </div>
      </div>
    </div>
  `;
}